import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Scrollbar, Controller } from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Scrollbar, Controller]);
export default (() => {
  window.addEventListener('load', function () {
    const timeline = new Swiper('.timeline .milestone', {
      freeMode: true,
      freeModeSticky: true,
      slidesPerView: 1,
      allowTouchMove: false,
      simulateTouch: false,
      initialSlide: this.document.querySelectorAll('.swiper-slide').length -1,
      navigation: {
        nextEl: '.timeline .milestone .swiper-button-next',
        prevEl: '.timeline .milestone .swiper-button-prev',
      },
      pagination: {
        el: '.timeline .milestone .swiper-pagination',
      },
    });

    const paginationSlider = new Swiper('.timeline .custom-pagination', {
      freeMode: true,
      freeModeSticky: true,
      slidesPerView: 4.4,
      initialSlide: this.document.querySelectorAll('.swiper-slide').length -1,
      breakpoints: {
        768: {
          slidesPerView: 7.5,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: this.document.querySelectorAll('.swiper-slide').length,
        },
      },
    });

    timeline.controller.control = paginationSlider
    const pagination = document.querySelectorAll('.timeline .pagination')

    pagination.forEach(element => {
      element.addEventListener('click', () => {

        const index = element.dataset.index
        timeline.slideTo(index)
      })
    })

    renderActiveBullet(pagination, timeline)
    timeline.on('slideChange', () => {
      renderActiveBullet(pagination, timeline)
    })
  })

})()




function renderActiveBullet(pagination, swiper) {
  pagination.forEach(element => {
    if (element.dataset.index == swiper.activeIndex) {
      element.classList.add('active')
    } else {
      element.classList.remove('active')
    }
  })
}


// WEBPACK FOOTER //
// ./scripts/layout/blocks/timeline.js